import React from 'react';
import { Link } from 'react-router-dom';
import { FiShield, FiShoppingBag, FiArrowRight } from 'react-icons/fi';
import { BiBuilding } from 'react-icons/bi';
import logo from '../assets/logo_white.png';

const PORTALS = [
  {
    title: 'Super Admin',
    description: 'Platform administration',
    path: '/admin/login',
    icon: FiShield,
    accent: '#3b82f6',
    sub: 'For Loysta operators only',
  },
  {
    title: 'Company Admin',
    description: 'HR & employee management',
    path: '/company/login',
    icon: BiBuilding,
    accent: '#00bf63',
    sub: 'Sign in with your company Google account',
  },
  {
    title: 'Vendor Portal',
    description: 'Offers & QR redemptions',
    path: '/vendor/login',
    icon: FiShoppingBag,
    accent: '#8b5cf6',
    sub: 'Sign in with your vendor Google account',
  },
];

const AllLogins = () => (
  <div style={{
    minHeight: '100vh',
    background: 'linear-gradient(180deg, #0f172a 0%, #0a1424 100%)',
    fontFamily: 'Plus Jakarta Sans, sans-serif',
    padding: '60px 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }}>
    <div style={{ width: '100%', maxWidth: 980 }}>
      <div style={{ textAlign: 'center', marginBottom: 44 }}>
        <img src={logo} alt="Loysta" style={{ height: 36, marginBottom: 22 }} />
        <h1 style={{
          color: 'white',
          fontSize: 30,
          fontWeight: 800,
          margin: '0 0 8px 0',
          letterSpacing: '-0.02em',
        }}>
          Choose your portal
        </h1>
        <p style={{ color: 'rgba(255,255,255,0.55)', fontSize: 15, margin: 0 }}>
          The employee experience lives in the Loysta mobile app — these portals are for admins, companies, and vendors.
        </p>
      </div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: 16,
      }}>
        {PORTALS.map((p) => {
          const Icon = p.icon;
          return (
            <Link key={p.path} to={p.path} style={{ textDecoration: 'none' }}>
              <div
                style={{
                  background: 'rgba(255,255,255,0.04)',
                  border: '1px solid rgba(255,255,255,0.08)',
                  borderRadius: 16,
                  padding: 24,
                  transition: 'all 0.2s ease',
                  cursor: 'pointer',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgba(255,255,255,0.07)';
                  e.currentTarget.style.borderColor = p.accent + '60';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'rgba(255,255,255,0.04)';
                  e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <div style={{
                  width: 44,
                  height: 44,
                  borderRadius: 12,
                  background: p.accent + '22',
                  color: p.accent,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: 18,
                }}>
                  <Icon size={22} />
                </div>
                <div style={{ color: 'white', fontSize: 17, fontWeight: 700, marginBottom: 4 }}>
                  {p.title}
                </div>
                <div style={{ color: 'rgba(255,255,255,0.55)', fontSize: 13, marginBottom: 18 }}>
                  {p.description}
                </div>
                <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: 12, lineHeight: 1.55, marginBottom: 22, flex: 1 }}>
                  {p.sub}
                </div>
                <div style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 6,
                  color: p.accent,
                  fontSize: 13,
                  fontWeight: 700,
                }}>
                  Open portal <FiArrowRight />
                </div>
              </div>
            </Link>
          );
        })}
      </div>

      <div style={{
        marginTop: 48,
        textAlign: 'center',
        color: 'rgba(255,255,255,0.32)',
        fontSize: 12,
      }}>
        © Loysta — employee benefits, made simple.
      </div>
    </div>
  </div>
);

export default AllLogins;
